import "core-js/modules/esnext.string.replace-all.js";
import "core-js/modules/esnext.string.replace-all.js";
var getDigitsForMasking = function getDigitsForMasking(length) {
  var digits = "";
  for (var index = 0; index < length; index++) {
    digits += "9";
  }
  return digits;
};
var scapeForMask = function scapeForMask(suffix) {
  var scape = suffix.replaceAll("a", "\\a");
  scape = scape.replaceAll("9", "\\9");
  scape = scape.replaceAll("*", "\\*");
  return scape;
};
var getMaskForQuantity = function getMaskForQuantity(digits, maskSuffix) {
  return digits + " " + scapeForMask(maskSuffix);
};
export { getDigitsForMasking, getMaskForQuantity };